const yup = require("yup");

const deleteRecord = yup.object({
  deleteRecord: yup.string().required("Delete is required"),
});

const createsession = yup.object({
  name: yup.string().required("Semester name is required"),
  code: yup
    .string()
    .min(2, "Minimum of 2 characters expected")
    .max(4, "Maximum of 4 characters expected")
    .required("Semester name a required fields"),
  status: yup.boolean().required("Status is a required fields"),
  admission: yup.boolean().required("Admission is a required fields"),
  semester: yup
    .number()
    .min(1, "Minimum of 1 characters expected")
    .max(2, "Maximum of 2 characters expected")
    .required("Semester is a required field"),
});

const moderate = yup.object({
  trimester: yup.string().required("Semester is required"),
  from: yup.number().min(1, "Minimum of 1 characters expected").required("From is a required field"),
  to: yup.number().min(1, "Minimum of 1 characters expected").required("To is a required field"),
});

const acceptance = yup.object({
  description: yup.string().required("Description is required"),
  amount: yup.number().min(1, "Minimum of 1 characters expected").required("Amount is a required field"),
  serviceID: yup.number().min(1, "Minimum of 1 characters expected").required("Service ID is a required field"),
  status: yup.boolean().required("Status is a required fields"),
});

const programme = yup.object({
  programme: yup.string().required("Programme is required"),
  from: yup.number().min(1, "Minimum of 1 characters expected").required("From is a required field"),
  to: yup
    .number()
    .min(1, "Minimum of 1 characters expected")
    .required("To is a required field")
    .test("is-greater-than-from", "To must be greater than or equal to From", function (value) {
      const { from } = this.parent;
      return value >= from;
    }),
});

const preresult = yup.object({
  programme: yup.string().required("Programme is required"),
  level: yup.string().required("Level is a required field"),
  semester: yup.string().required("Semester is a required field"),
});

const otherServices = yup.object({
  serviceid: yup.string().required("Remita service ID is required"),
  amount: yup.number().required("Amount is a required field"),
  label: yup.string().required("Label is a required field"),
  description: yup.string().required("Description is a required field"),
  status: yup.boolean().required("Status is a required field"),
});


module.exports = {
  createsession,
  deleteRecord,
  preresult,
  moderate,
  programme,
  acceptance,
  otherServices,
};
